import { render, staticRenderFns } from "./PackageManagement.vue?vue&type=template&id=19e9a380&scoped=true&"
import script from "./PackageManagement.vue?vue&type=script&lang=js&"
export * from "./PackageManagement.vue?vue&type=script&lang=js&"
import style0 from "./PackageManagement.vue?vue&type=style&index=0&id=19e9a380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e9a380",
  null
  
)

export default component.exports